export const list = {
  pathname: '/private/analyses',
  search: ({ limit, cursor, order, owner } = {}) => {
    const params = {}

    if (limit) {
      params.limit = limit
    }
    if (cursor) {
      params.cursor = cursor
    }
    if (order) {
      params.order = order
    }
    if (owner) {
      params.filter = `owner:${owner}`
    }

    return params
  }
}

export const details = {
  pathname: ({ id }) => `/private/analyses/${id}`
}

export const analysisItem = {
  pathname: ({ id }) => `/private/analyses/${id}/item`
}

export const analysisSubmitter = {
  pathname: ({ id }) => `/private/analyses/${id}/submitter`
}
